(function ($, ko) {

    function calculateColorScheme(count_colors) {
        var calculateTransparentColor = function (foregroundColor, opacity, backgroundColor) {
            backgroundColor = backgroundColor || '#FFFFFF';
            opacity = (opacity || 0.67) * 1.0; // default opacity and make it float
            if (opacity < 0.0 || opacity > 1.0 || !this.COLOR_REGEX.test(foregroundColor) || !this.COLOR_REGEX.test(backgroundColor)) {
                // todo: log invalid input
                return foregroundColor;
            }
            var foregroundRGB = this.colorHexToRGB(foregroundColor);
            var backgroundRGB = this.colorHexToRGB(backgroundColor);
            var finalRed = Math.round(backgroundRGB.r * (1 - opacity) + foregroundRGB.r * opacity);
            var finalGreen = Math.round(backgroundRGB.g * (1 - opacity) + foregroundRGB.g * opacity);
            var finalBlue = Math.round(backgroundRGB.b * (1 - opacity) + foregroundRGB.b * opacity);
            return '#' + this.toHex2(finalRed) + this.toHex2(finalGreen) + this.toHex2(finalBlue);
        }.bind({
            colorHexToRGB: function (htmlColor) {
                var arrRGB = htmlColor.match(this.COLOR_REGEX);
                return { "r": parseInt(arrRGB[1], 16), "g": parseInt(arrRGB[2], 16), "b": parseInt(arrRGB[3], 16) };
            },
            toHex2: function (number) {
                return (256 + number).toString(16).slice(-2);
            },
            COLOR_REGEX: /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        });

        var investments_donut_colors = [];
        (function () {
            // old colors ['#ED9B9B', '#A9CEB5', '#B5C7E5', '#6FCBEA', '#F5A026', '#D76363', '#75A485', '#4e638a', '#4DAECE', '#D88D21']
            //var colors = ['#ae0c4d', '#1d5077', '#1bab5f', '#e5e748', '#e2a719', '#955ba3', '#d794d5', '#5dc7d7', '#e06998', '#5fa1d4', '#62dc9c', '#96980e', '#e26019', '#4d2557', '#584b5b', '#0c707f'],
            var colors = [$.cdh.brandData.InvestmentColor1, $.cdh.brandData.InvestmentColor2, $.cdh.brandData.InvestmentColor3, $.cdh.brandData.InvestmentColor4, $.cdh.brandData.InvestmentColor5],
                i = 0;
            if (count_colors > colors.length) {
                count_colors = colors.length;
            }
            while (i < count_colors) { investments_donut_colors.push(calculateTransparentColor(colors[i++])); }
            i = 0;
            while (i < count_colors) { investments_donut_colors.push(colors[i++]); }
        }());
        return investments_donut_colors;
    }

    ko.bindingHandlers.chartInvestment = {
        update: function (element, valueAccessor) {
            var investments = ko.unwrap(valueAccessor());
            if (!investments) return;

            var dataArr = [];
            for (var i = 0; i < investments.length; i++) {
                var obj = { "label": investments[i].ItemName, "value": investments[i].ItemMarketValue };
                dataArr.push(obj);
            }

            $.extend(true, $.jqx._jqxChart.prototype.colorSchemes, [{ name: 'investments-donut', colors: calculateColorScheme(dataArr.length) }]);

            //chart settings
            var chartData = {
                element: element,
                colorScheme: 'investments-donut',
                dataArr: dataArr
            };
            //create the chart
            $.cdh.charts.bindDonutChart (chartData);
        }
    };

    ko.bindingHandlers.chartInvestmentBar = {
        update: function (element, valueAccessor) {
            var investments = ko.unwrap(valueAccessor());
            if (!investments)
                return;

            var maxData = 0;
            var dataArr = [];
            for (var i = 0; i < investments.length; i++) {
                var obj = { "label": investments[i].ItemName, "value": investments[i].ItemMarketValue };
                if (obj.value > maxData)
                    maxData = obj.value;
                dataArr.push(obj);
            }

            //chart settings
            var chartData = {
                element: element,
                dataArr: dataArr,
                settings: {
                    title: '',
                    description: '',
                    showLegend: false,
                    enableAnimations: true,
                    showBorderLine: false,
                    categoryAxis:
                    {
                        dataField: 'label',
                        showGridLines: false,
                        flip: false,
                        textRotationAngle: 75
                    },
                    source: dataArr,
                    valueAxis: {
                        minValue: 0,
                        maxValue: maxData < 100 ? maxData + 10 : maxData < 1000 ? maxData + 50 : maxData + 150,
                        labels: { horizontalAlignment: 'right',  formatSettings: { prefix: '$', decimalPlaces: 2 } },
                        tickMarks: { color: '#BCBCBC' },
                        gridLines: { visible: true }
                    },
                    xAxis: {                        
                        gridLines: { visible: false }           
                    },
                    seriesGroups:
                    [
                        {
                            type: 'column',
                            columnsGapPercent: 100,
                            useGradientColors: false,
                            series: [
                                {
                                    dataField: 'value',
                                    labels: {
                                        visible: true,
                                        verticalAlignment: 'top',
                                        offset: { x: 0, y: -20 }
                                    },
                                    formatFunction: function (value) {
                                        return '$' +  value;
                                    },
                                    colorFunction: function (value, itemIndex, serie, group) {
                                        if (itemIndex === 0)
                                            return $.cdh.brandData.InvestmentColor1;
                                        if (itemIndex === 1)
                                            return $.cdh.brandData.InvestmentColor2;
                                        if (itemIndex === 2)
                                            return $.cdh.brandData.InvestmentColor3;
                                        if (itemIndex === 3)
                                            return $.cdh.brandData.InvestmentColor4;

                                        return $.cdh.brandData.InvestmentColor5;
                                    }

                                }
                            ]
                        }
                    ],
                }
            };
            //create the chart
            $.cdh.charts.bindColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartInvestmentLegend = {
        update: function (element, valueAccessor) {
            var investmentIndex = ko.unwrap(valueAccessor());
            if (investmentIndex == undefined || investmentIndex < 0) return;

            //Add colors to legends
            $.extend(true, $.jqx._jqxChart.prototype.colorSchemes, [{ name: 'investments-donut', colors: calculateColorScheme(15) }]);
            var colorScheme = $.grep($.jqx._jqxChart.prototype.colorSchemes, function (obj, i) {
                return (obj.name == 'investments-donut');
            });
            var charts_colors = colorScheme[0].colors;
            //render circles for legend
            $(element).css('background', charts_colors[charts_colors.length / 2 + investmentIndex]);
        }
    };

})(jQuery, ko);